import ExternalApiRequest from "./../utils/ExternalApiRequest";
import actionTypes from "./../constants/actionTypes";
import { getList } from "./formActions";
import { toast } from 'react-toastify';
import { toProperString, formatValueWithType, formatIndianCurrency } from "../utils/utility";

export const listTrackings = (requestPayload, listFormKey) => {
    try {
        return async (dispatch, getState) => {
            const { fetchWithChart = false } = requestPayload;
            const { forms = {} } = getState();
            const { formJson = {} } = forms;
            const formData = formJson[listFormKey] || {}
            const listResponse = await getList(requestPayload, "listTracking", "trackings");
            const listJson = formListJson(formData, listResponse);

            if (fetchWithChart) {
                const chartData = parseChartData(listResponse);
                dispatch({
                    type: actionTypes.HOME.TRACKING_CHART_DATA,
                    payload: chartData,
                })
            }

            return dispatch({
                type: actionTypes.HOME.TRACKING_LIST,
                payload: listJson,
            });
        }
    } catch (error) {
        console.log(error);
    }
}

const formListJson = (formPayload, listPayload) => {
    const { data = {}, meta = {} } = formPayload;
    const { trackings = [], meta: listMeta = {} } = listPayload;
    const { section = [] } = data;
    const [firstSection = {}] = section;
    const { fields = [] } = firstSection;
    const listData = trackings.map(tracking => {
        const { companyId = '', additionalInfo = {}, status = '', actions = [], name = '', ltp = 0, change = 0, description = '', orderType = '' } = tracking;
        const { telegramAlert = false, qty = 0, buyPrice = 0 } = additionalInfo;
        const rowData = fields.reduce((accum, field, index) => {
            let value = '';
            switch (field.id) {
                case "description": {
                    value = `${description} (${toProperString(orderType)})`;
                    break;
                }
                case "companyId": {
                    value = `${name} (${companyId})`;
                    break;
                }
                case "changeValue": {
                    const investedAmount = buyPrice * qty;
                    const currentAmount = ltp * qty;
                    const valueChange = currentAmount - investedAmount;
                    value = {
                        component: <td class="text-start">
                            <span style={{ color: `${valueChange < 0 ? 'red' : 'green'}` }} >{valueChange < 0 ? `${formatIndianCurrency(valueChange)}` : `+${formatIndianCurrency(valueChange)}`}</span>
                        </td>, value: valueChange
                    }
                    break;
                }
                case "currentValue": {
                    const currentAmount = ltp * qty;
                    value = {
                        component: <td class="text-start">
                            {formatIndianCurrency(currentAmount)}
                        </td>, value: currentAmount
                    };
                    break;
                }
                case "investedValue": {
                    const investedAmount = buyPrice * qty;
                    value = {
                        component: <td class="text-start">
                            {formatIndianCurrency(investedAmount)}
                        </td>, value: investedAmount
                    };
                    break;
                }
                case "buyPrice": {
                    value = {
                        component: <td class="text-start">
                            {formatIndianCurrency(buyPrice)} (QTY:{qty})
                        </td>, value: buyPrice
                    };
                    break;
                }
                case "ltp": {
                    value = {
                        component: <td class="text-start">
                            {formatIndianCurrency(ltp)}
                        </td>, value: ltp
                    };
                    break;
                }
                case "targetPrice": {
                    const { targetPrice = 0 } = tracking;
                    value = {
                        component: <td class="text-start">
                            {formatIndianCurrency(targetPrice)}
                        </td>, value: targetPrice
                    };
                    break;
                }
                case "stopLossPrice": {
                    const { stopLossPrice = 0 } = tracking;
                    value = {
                        component: <td class="text-start">
                            {formatIndianCurrency(stopLossPrice)}
                        </td>, value: stopLossPrice
                    };
                    break;
                }
                case "changePercentage": {
                    value = {
                        component: <td class="text-start">
                            <span style={{ color: `${change < 0 ? 'red' : 'green'}` }} >{change < 0 ? `${change}%` : `+${change}%`}</span>
                        </td>, value: change
                    };
                    console.log("change", change, value);
                    break;
                }
                default: value = tracking[field.id] || additionalInfo[field.id] || '';
            }
            return { ...accum, [field.id]: value };
        }, {});
        return rowData;
    });
    return { headers: fields, data: listData, meta };
}

const parseChartData = (listPayload) => {
    const { trackings = [], meta: listMeta = {} } = listPayload;
    const _chartValues = [];
    const lastDaysChange = [];
    trackings.forEach(tracking => {
        const { companyId = '', additionalInfo = {}, chartValues = [], name = '', } = tracking;
        const { qty = 0, buyPrice = 0 } = additionalInfo;
        if (chartValues.length == 0)
            return;
        const lastValue = chartValues[chartValues.length - 1];
        const { c: initialPrice = 0 } = lastValue;
        let data = chartValues.map(datum => {
            const { d = '', c: close = 0 } = datum;
            return {
                date: d, value: formatValueWithType(((close - buyPrice) / buyPrice) * 100),
                close
            }
        });
        _chartValues.push({
            name: `${name} (${companyId})`,
            data: data.reverse(),
        });

        // data = chartValues.map(datum => {
        //     const { d = '', c: close = 0 } = datum;
        //     return {
        //         date: d, value: formatValueWithType(((close - initialPrice) / initialPrice) * 100)
        //     }
        // });
        // lastDaysChange.push({
        //     name: `${name} (${companyId})`,
        //     data: data.reverse(),
        // });
    });
    return { chartValues: _chartValues, lastDaysChange };
}